/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { DataTabEntrypointProps } from './DataTab.entrypoint.types.tsx';

type DataTabEntryPointComponent = EntryPointComponent<{}, {}, DataTabEntrypointProps, {}>;

export const dataTabEntryPoint: EntryPoint<DataTabEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<DataTabEntryPointComponent>(
		/* webpackChunkName: "async-data-tab" */ './DataTab.tsx',
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
